import api from '@/api'
// eslint-disable-next-line
import axios from '@/axios'
import qs from 'qs';

const path = '/LicenciaCargoPersonal'

export default{
  getLista(obj) {
    console.log("getLista", obj);
    return axios.get(`${api.url + path}/GetLista`,{
      params: obj
    })
  },

  get (obj) {
    var urlrequest = api.url + path;
    console.log('get ', urlrequest, obj);
    return axios.get(`${urlrequest}/Get`,{
      params:obj
    })
  },

  getFormData (id) {
    console.log('getFormData')
    return axios.get(`${api.url + path}/GetFormData`,{
      params: {
        'id': id,
        }
    })
  },

  crear(obj){
    console.log('crear', obj)
    return axios.post(`${api.url + path}/Crear`, obj)
  },
  cambiar(obj){
    console.log('cambiar', obj)
    return axios.post(`${api.url + path}/Cambiar`, obj)
  },
  eliminar(obj){
    console.log('eliminar', obj)
    return axios.post(`${api.url + path}/EliminarById`, obj)
  },

  findl(obj){
    console.log('Find', obj);
    return axios.post(`${api.url + path}/Find`, obj)
  }


}



// WEBPACK FOOTER //
// ./src/services/licenciacargopersonal/index.js